function setItem(key: string, v: any) {
  try {
    localStorage.setItem(key, v);
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error('err', e);
  }
}

function getItem(key: string): any {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error('err', e);
    return null;
  }
}

function isValid() {
  try {
    // @ts-ignore
    if (localStorage.setItem){
      return true;
    }
  } catch (e) {
    return false;
  }
}

export default {
  setItem,
  getItem,
  isValid
}
